/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RevokeGrantCmd } from '../../models/revoke-grant-cmd';
import { ValidationError } from '../../models/validation-error';

export interface RevokeGrants$Params {
  id: string;
      body?: RevokeGrantCmd
}

export function revokeGrants(http: HttpClient, rootUrl: string, params: RevokeGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
  const rb = new RequestBuilder(rootUrl, revokeGrants.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ValidationError>>;
    })
  );
}

revokeGrants.PATH = '/api/users/{id}/revoke-grants';
